export default "__VITE_ASSET__BJOplv_K__"